import { createContext } from 'react';

const CompanyContext = createContext(() => {});

export { CompanyContext };
